import React from "react";
class UserClass extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            count: this.props.count
        }
    }
    render() {
        return(
            <div className="userClass"> 
                <h1>User Class</h1>
                <h2>Name : {this.props.name}</h2>
                <h2>Contact : {this.props.contact}</h2>
                <h2>LeetCode : {this.props.leetcode}</h2>
                <h2>Count : {this.state.count}</h2>
                <button onClick={()=>{this.setState({count : this.state.count+1})}}>Increase Count</button>
            </div>
        )
    }
}
export default UserClass;